import { Tooltip, Button,   } from "@material-tailwind/react";
import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import AAvatar from '../partials/AAvatar'
import './sidebar.css'
import { SideBarContext } from '../../store/sidebar/context';
import AIcon from '../partials/AIcon'
import { useShared } from "../../hooks/useShared";
import { sidebarMenu } from "./sideMenuList";
import { getLanguage} from 'react-multi-lang'
import LanguagesMenu from "../header/menus/LanguagesMenu";



export default function SidebarContents() {
    const location = useLocation()
    //const { pushSideBar, setPushSideBar } = React.useContext(SideBarContext);

    const [selectedItem, setSelectedItem] = useState(false)
    const [showChildren, setShowChildren] = useState(false)
    const [authMenu, setAuthMenu] = useState([])

    const { auth, itemCounts,  pushSideBar, setPushSideBar } = useShared();

    useEffect(() => {
        openSubMenu(null)
        setAuthMenu([])
        sidebarMenu?.map(sm => {
            if (auth.hasRole(sm?.roles)) {
                setAuthMenu(pre => [...pre, sm])
            }
            return sm;
        })

    }, [])



    const setSideBarMenuItems = (sm) => {
        return (
            <>
                <AIcon size={18} name={sm?.icon} className={` ${!pushSideBar && '!mr-3'}  ${sm?.colors[0]} ${!pushSideBar && getLanguage() === 'dr' ? '!ml-2' : ''}`} />

                {!pushSideBar && <span className={getLanguage() === 'dr' ? 'amiriR text-base' : 'text-xs'}>{getLanguage() === 'dr' ? sm.name_af : sm?.name} </span>}
                {!pushSideBar && sm?.count > 0 && <AAvatar num={sm?.count} className={sm?.colors[1]} />}
                {!pushSideBar && sm?.children.length > 0 && <AIcon size={20} name="chevron-down-outline" className={`  ${!pushSideBar && getLanguage() === 'dr' ? '!mr-auto' : 'ml-auto'} ${sm?.name === selectedItem?.name && showChildren ? "rotate-180" : ""} `} />}

            </>
        )
    }

    const MyNavBar = ({ sm }) => {
        return (
            <NavLink className={({ isActive }) => ` duration-1000  menuClass ${isActive ?
                ` bg-main-color !text-white font-semibold hover:!bg-main-color ${sm?.children?.length > 0 && selectedItem?.link === sm?.link && '!rounded-b-none'}` : 'text-gray-700'}`} to={sm?.link}>
                {setSideBarMenuItems(sm)}
            </NavLink>
        )
    }

    const handleMenuClick = (sm) => {

        if (pushSideBar && sm?.children.length > 0) {
            setPushSideBar(false);
        }
        openSubMenu(sm)

    }


    useEffect(() => {
        if (itemCounts?.length > 0) {
            authMenu.filter((x, i) => itemCounts.some(y => {
                if (x.link === y.name) {
                    authMenu[i].count = y.count
                    return true
                }
                return false
            }));
        }
    }, [])


    const openSubMenu = (sm) => {
        if (sm?.children?.length > 0) {
            setShowChildren(pre => !pre) //when open and close
            setSelectedItem(sm)
        }

        else if (sm === null) {
            const isIt = authMenu.find((s, i) => s?.children?.find(c => {
                if (c?.link === location.pathname) return authMenu[i]
            }))
            if (isIt) {
                setShowChildren(true)
                setSelectedItem(isIt)

            }
            else {
                const test = authMenu.find((s, i) => {
                    if (s?.link === location.pathname) {
                        return authMenu[i]
                    }
                })
                setSelectedItem(test)
            }

        } else {
            setShowChildren(false)
            setSelectedItem(sm)
        }
        
    }

    const getDirection = () => getLanguage() === 'dr' ? "rtl" : 'ltr'


    return (
        <div className="sidebar-content px-4 py-6 overflow-y-auto h-[88vh] api-scroll">
            <ul className="flex flex-col w-full">

                {
                    authMenu.map((sm, index) => (
                        <li className="my-px" key={index}  >
                            <div onClick={() => handleMenuClick(sm)} style={{ direction: getDirection() }}>
                                {pushSideBar ?

                                    <Tooltip content={getLanguage() === 'dr' ? sm.name_af : sm?.name} placement="right" animate={{ mount: { scale: 1, y: 0 }, unmount: { scale: 0, y: 25 } }}>
                                        {/* When menu is collapsed show menu item name in Tooltip */}
                                        <Button className="p-0 m-0 bg-inherit bottom-0 shadow-none hover:shadow-none">
                                        <>{sm?.children?.length > 0 ?
                                        <div className={` duration-1000  menuClass text-gray-700 cursor-pointer ${selectedItem?.name === sm?.name && showChildren ?
                                            'bg-main-color !text-white font-semibold hover:!bg-main-color !rounded-b-none' : ''}`} >
                                            {setSideBarMenuItems(sm)}
                                        </div> : sm.name !== "Admin Roles" &&<MyNavBar sm={sm} />

                                    }</>
                                        </Button>
                                    </Tooltip>
                                    :
                                    <>{sm?.children?.length > 0 ?
                                        <div className={` duration-1000  menuClass text-gray-700 cursor-pointer ${selectedItem?.name === sm?.name && showChildren ?
                                            'bg-main-color !text-white font-semibold hover:!bg-main-color !rounded-b-none' : ''}`} >
                                            {setSideBarMenuItems(sm)}
                                        </div> : sm.name === "Admin Roles" ?
                                            <div className={`text-gray-300  mt-3  pl-1 rounded-sm ${getLanguage() === 'dr' ? 'amiriR text-base text-right' : 'text-sm'}`}>{getLanguage() === 'dr' ? sm.name_af : sm?.name}</div>
                                            : <MyNavBar sm={sm} />

                                    }</>
                                }
                            </div>

                            {/*  submenu */}
                            {sm?.children.length > 0 &&
                                <ul className={`${selectedItem?.name === sm?.name && showChildren && !pushSideBar ? "max-h-50 p-1 border border-main-color rounded-b-lg" : "max-h-0 border-none"} overflow-hidden  duration-500  flex flex-col relative bg-red-500 `}>
                                    {sm?.children.map((ch, i) => {
                                        return (
                                            <li style={{ direction: getDirection() }} key={i}>
                                                {auth.hasRole(ch?.roles) && <NavLink className={({ isActive }) => `menuClass  m-1 ${isActive ? '!text-gray-900 bg-gray-300/50' : ''}`} to={ch.link}>
                                                    <span className={getLanguage() === 'dr' ? 'amiriR text-base' : ''}>{getLanguage() === 'dr' ? ch.name_af : ch?.name}</span>
                                                </NavLink>}
                                            </li>
                                        )
                                    })}
                                </ul>
                            }
                        </li>
                    ))
                }
                <li>
                    <LanguagesMenu />
                </li>
            </ul>
        </div>
    )
}
/* {com.isRole(sm?.roles) && <NavLink className={({ isActive }) => `menuClass ${isActive ? `bg-main-color text-gray-100 ` : `text-gray-300 `}`} to={sm?.link}> */